import React, {useEffect} from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { connect } from 'react-redux'

import { confirmAlert } from 'react-confirm-alert';
import { GenericTableButton} from "../../../components/buttons/buttonsActions";
import {
    ARE_YOU_SHURE_MSG,
    ARE_YOU_SHURE_TITLE,
    LIST, NO, NO_DATA_FOUND, YES
} from "../../../components/i18n/i18n";

import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";
import {ActiveFormatter} from "../../../components/tables/activeFormater";
import {remove, search} from "../../../redux/actions/hotel/terminalActions";
import {setFilter, setTableParams} from "../../../redux/actions/generalActions/listActions";
import {setViewMode} from "../../../redux/actions/generalActions/mainActions";
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import TerminalFilters from "./_filters";
import {FL_AIRPORT} from "../../../components/i18n/formLabels";

const TerminalList = props => {
    const { app } = props.mainProps;
    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listProps;

    useEffect(() => {
        if (app?.fbDataBase?.id !== undefined){
            const _fbDataBaseId = app?.fbDataBase?.id
            const _filter = {
                fbDataBase: { id: _fbDataBaseId },
                item: {
                    code: filter?.item?.code || null,
                    status: filter?.item?.status || null,
                }
            };
            props.setFilter(_filter);
            refreshDataList(pageIndex, pageSize, _filter);
        }
    }, [pageIndex, pageSize, app]);

    const refreshDataList =  (_pageIndex, _pageSize, _filter) => props.search(_pageIndex, _pageSize, _filter)

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams( tableChangeParams.sizePerPage, currentIndex );
    };

    const refreshFiltered = (_dataFilter) => {
        props.setFilter(_dataFilter);
        refreshDataList(pageIndex, pageSize, _dataFilter);
    }

    const confirmDelete = (data) => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            props.remove(data.id)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    };

    const activeFormatter = (cell) => {
        return (
            <ActiveFormatter active={cell}/>
        );
    }

    const actionsFormatter = (cell, row) => {
        return (
            <div className="float-left">
                <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
                <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => {
                    props.setViewMode('FORM');
                    props.setItem(row);
                    props.setForm(true, false, false);
                }}/>
            </div>
        );
    }

    const columns = [
        {
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'uid',
        text: 'uid',
        headerStyle: { width: '200px' }
    }, {
        dataField: 'airport',
        text: `${FL_AIRPORT}`,
        headerStyle: { width: '200px' },
        formatter: (cell) => cell?.name
    }, {
        dataField: 'code',
        text: 'Código',
    },{
        dataField: 'number',
        text: 'Número',
        headerStyle: { width: '80px' },
        headerAlign: 'center',
        align: 'center',
    }, {
        dataField: 'status',
        text: "Activo",
        headerAlign: 'center',
        align: 'center',
        headerStyle: {width: '80px'},
        formatter: activeFormatter
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '140px'},
        headerAlign: 'center',
        align: 'center',
        formatter: actionsFormatter
    }];

    return (
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-list-alt mr-2"> </i>{LIST}
            </CardTitle>

            <TerminalFilters refreshFiltered={ refreshFiltered } />

            <CardBody className="">
                <BootstrapTable
                    striped hover
                    tableHeaderClass='mb-0'
                    remote
                    keyField="id"
                    data={listDomainObjects || [] }
                    columns={columns}
                    noDataIndication={ NO_DATA_FOUND }
                    pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                    onTableChange={handleTableChange}
                />
            </CardBody>
        </Card>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    listProps : state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    search,
    remove,
})

export default connect(mapStateToProps, mapActionsToProps)(TerminalList)